import { computed, defineComponent, watch } from "@vue/composition-api";
import useUserPublicData from "@/hooks/useUserPublicData";
import { userPublicDataFieldsWithStoryInfo } from "@/lib/fieldsHelper";
import { getRecentlyActiveTime } from "@/lib/time";
import { ROLES } from "@/const";

export default defineComponent({
  name: "usersRecentlyActiveController",
  props: {
    role: { type: String as () => ROLES, required: true },
  },
  setup(props, { emit }) {
    const { data, render, getFirstPage } = useUserPublicData(
      computed(() => ({
        role: props.role,
        lastSeenAfter: getRecentlyActiveTime().toISOString(),
        isOnline: false,
      })),
      undefined,
      userPublicDataFieldsWithStoryInfo()
    );
    const getData = async () => {
      await getFirstPage();
      emit("load", data.value?.totalRecords);
    };

    watch(
      () => props.role,
      async () => {
        await getData();
      },
      { immediate: true }
    );
    return render;
  },
});
